import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { CHECKOUT_URL, urgency } from '../data/content';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-ink text-white" data-id="element-180" data-mp="3cvy0d4fmvn7h">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mx-auto flex max-w-6xl flex-col items-center gap-1 px-4 py-2.5 text-center transition-colors duration-150 ease-out hover:bg-white/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-grass sm:flex-row sm:justify-center sm:gap-3 sm:text-left" data-id="element-181" data-mp="37va526kdgk7g">
        <p className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-wide" data-id="element-182" data-mp="2p6deaco6o9tz">
          <AlertTriangleIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-183" data-mp="2k7tsqddi5025" />
          {urgency.headline}
        </p>
        <p className="text-[13px] text-white/70" data-id="element-184" data-mp="2b5aphs5t0lfd">
          {urgency.detail}{' '}
          <span className="font-bold text-white" data-id="element-185" data-mp="1rxaurb0klxmv">
            Cupos restantes: {urgency.spotsLeft}
          </span>
        </p>
      </a>
    </div>;
}